/**
 * Function to fix a unescape string value
 * @param userInput Escapes a value when sending to API
 * @returns Fixed value
 */
export function escape(userInput: string | number | boolean) {
    return userInput.toString().replace(/'/g, "''");
}
